import { useState } from 'react';
import '../styles/Projects.css';
import { TargetProject } from './ui/TargetProject.jsx';
import qgis from '../assets/gis.png';
import python from '../assets/python.png';
import sql from '../assets/sql.png';
import appconstanciasnodeudor from '../assets/appconstanciasnodeudor.png';
import appempleoscusco from '../assets/appempleoscusco.png';
import appqm from '../assets/appqm.png';
import appcontrolreserva from '../assets/appcontrolreserva.png';
import appnotecalles from '../assets/appnotecalles.png';
import appreservas from '../assets/appreservas.png';
import appconsultadeudas from '../assets/appconsultadeudas.png';

import react from '../assets/react.svg';
import javascript from '../assets/javascript.svg';
import css from '../assets/css3.svg';
import html from '../assets/html5.svg';
import figma from '../assets/figma.svg';
import iconC from '../assets/iconC.png';
import gisImage from '../assets/gisimage.PNG';
import postman from '../assets/postman.png';
import iconPhp from '../assets/iconPhp.png';
import iconMapbox from '../assets/iconMapbox.png';
import iconGeoJson from '../assets/iconGeoJson.png';
import iconAndroid from '../assets/iconAndroid.svg';
import iconFirebase from '../assets/iconFirebase.png';
import iconBat from '../assets/iconBat.png';
import iconJava from '../assets/iconJava.png';
import iconVue from '../assets/iconVue2.png';
import iconNode from '../assets/iconNode.png';
import iconCordova from '../assets/iconCordova.png';
import iconMySql from '../assets/mysql.svg';
import iconGit from '../assets/git.svg';
import iconTerminal from '../assets/terminal.svg';

export function Projects(){
  const [showAll, setShowAll] = useState(false);

  return(
    <section id="projects" className="projects">
      <h3 className="title">Proyectos de transformación digital</h3>

      <div className="projects-content">

        <TargetProject
          name="Migración de Caja Municipal"
          period="May. – ago. 2026"
          category="Modernización de sistemas heredados"
          desc="Lideré la transición de un sistema heredado a una arquitectura moderna, con custodia técnica y soporte continuo. Diseñé estrategias de mitigación de riesgos operativos y mejoré la seguridad con autenticación centralizada."
        />

        <TargetProject
          name="Automatización CI/CD y DevOps"
          period="Feb. – abr. 2026"
          category="Entrega continua y DevOps"
          desc="Implementé pipelines CI/CD con GitLab y Jenkins y reestructuré los despliegues del sistema de asistencia y RRHH. Reduje los tiempos de iteración, los errores manuales y la carga operativa del equipo."
          techs={[iconGit, iconTerminal]}
        />

        <TargetProject
          name="Caja Municipal - La Convención"
          period="Ago. 2025 – ene. 2026"
          category="Digitalización de la recaudación"
          desc="Aplicación en Java con backend en PHP y SQL Server para dispositivos POS. Recaudación con validación en tiempo real, operación offline, control de usuarios y tickets oficiales en impresoras ESC/POS. Redujo en 100% los errores de registro."
          techs={[iconJava, iconPhp, sql]}
        />

        <TargetProject
          name="SIG Compactadores y Rutas"
          period="Nov. – dic. 2024"
          category="Gestión geoespacial de limpieza urbana"
          desc="SIG financiado por la Fundación Social Universal para la Municipalidad de Santiago. Optimiza el monitoreo de compactadores y la planificación de rutas de recolección, y mejora la gestión de los recursos municipales."
          techs={[qgis, python, sql]}
        />

        <TargetProject
          name="Reserva Piscinas"
          image={appreservas}
          desc="Sistema web de reservas para las pozas de Santa Teresa - Cocalmayo, creada utilizando HTML, CSS, JS y conexión API REST . Net Core 3.1 (SQL Server). Software registrado en INDECOPI como coautor (partida N.° 01328-2023)."
          demo={true}
          techs={[iconVue,iconC,javascript, html, css, sql]}
          github="https://github.com/Becessj/Reservas-Cocalmayo"
          linkDemo="https://github.com/Becessj/Reservas-Cocalmayo"
        />

        <TargetProject
          name="Constancias"
          image={appconstanciasnodeudor}
          desc="Sistema web para consultar deudas y generar constancia de no deudor, está implementado con REACT JS y conexion API REST en .net core 3.1. (SQL Server). Proyecto financiado por la Diputación de Córdoba (España)."
          demo={true}
          techs={[react,sql, iconC, postman]}
          github="https://github.com/Becessj/Consulta-Notarias"
          linkDemo="https://github.com/Becessj/Consulta-Notarias"
        />

        <TargetProject
          name="SIG Python"
          image={gisImage}
          desc="Sistema de Información Geográfico desarrollado en Qgis 3.10 LTR, creada utilizando Python, librería PyQgis y vistas en SQL Server, el SIG esta enlazado a los sistemas de información de escritorio de Rentas, Agua y Limpieza pública, actualmente activos en diferentes municipalidades de la región del Cusco."
          demo={true}
          techs={[qgis, python, sql, iconBat]}
          github="https://github.com/Becessj/Sistema-de-Informacion-Geografico-en-QGIS"
          linkDemo="https://github.com/Becessj/Sistema-de-Informacion-Geografico-en-QGIS"
        />

        <TargetProject
          name="Obras Inconclusas"
          image={appqm}
          desc="App Web que muestra un mapa de obras inconclusas en la provincia de Cusco, los usuarios podrán identificar obras georeferenciadas con sus respectivos detalles."
          demo={true}
          techs={[javascript, html, css, iconMapbox, iconGeoJson, ]}
          github="https://github.com/Becessj/OBRASINCONCLUSASQM"
          linkDemo="https://becessj.github.io/OBRASINCONCLUSASQM/"
        />

        {showAll && (
          <>
            <TargetProject
              name="Santiago Limpio"
              period="Ene. – abr. 2025"
              category="App móvil para limpieza urbana"
              desc="App móvil en React Native con backend en Node.js y MySQL que automatiza la planificación de rutas de recolección y fortalece la transparencia en la gestión de la limpieza urbana."
              techs={[react, iconNode, iconMySql]}
            />

            <TargetProject
              name="API RENIEC, SUNAT y Tipo de Cambio"
              period="Oct. – nov. 2024"
              category="Integración de servicios (API REST)"
              desc="API REST segura para consultar personas naturales (DNI), personas jurídicas (RUC) y tipo de cambio. Con caché y persistencia local reduce el consumo de tokens externos y mejora el tiempo de respuesta desde servidor propio."
              techs={[postman]}
            />

            <TargetProject
              name="Asistencia y Certificaciones"
              period="Set. – oct. 2024"
              category="Gestión pública digital"
              desc="Plataforma de las Jornadas de Modernización y Transformación Digital en la Gestión Pública, con asistencia en tiempo real y certificados digitales automáticos. Redujo en más de 70% el tiempo de validación."
            />

            <TargetProject
              name="Portales Web Municipales"
              period="Ago. 2022"
              category="Portales institucionales"
              desc="Portales web institucionales de las municipalidades distritales de Zurite, Pucyura y Huarocondo."
            />

            <TargetProject
              name="Empleo Cusco"
              image={appempleoscusco}
              desc="Aplicación Web donde se puede encontrar empleos que se acomoden a un perfil en la región de Cusco."
              demo={true}
              techs={[iconPhp, javascript, html, css, figma, iconAndroid, iconJava, iconFirebase]}
              github="https://github.com/Becessj/Empleo-Cusco"
              linkDemo="https://empleoscusco.guamanpoma.org/"
            />

            <TargetProject
              name="Control de Acceso"
              image={appcontrolreserva}
              desc="Módulo web para el control de acceso después de una reserva para las pozas de Santa Teresa - Cocalmayo, creada utilizando HTML, CSS, JS y conexión API REST . Net Core 3.1 (SQL Server)."
              demo={true}
              techs={[javascript, html, css,iconC,sql]}
              github="https://github.com/Becessj/Reservas-Cocalmayo"
              linkDemo="https://github.com/Becessj/Reservas-Cocalmayo"
            />

            <TargetProject
              name="App Móvil 'No te calles' "
              image={appnotecalles}
              desc="App Móvil creada utilizando Córdova JS, Android Studio, HTML, CSS, JS. Este aplicativo sirve como una herramienta informativa para aquellas personas que deseen denunciar y actuar frente a casos de violencia familiar, física, psicológica, sexual o económica. Esta herramienta mostrará las rutas mas accesibles para lugares de apoyo para la mujer, niño o adolescente en la ciudad del Cusco."
              demo={true}
              techs={[javascript, html, css, iconNode,iconCordova, iconAndroid]}
              github="https://github.com/Becessj/No-te-calles"
              linkDemo="https://github.com/Becessj/No-te-calles"
            />

            <TargetProject
              name="Publicación Cuentas"
              image={appconsultadeudas}
              desc="Aplicación Web de publicación de cuentas, se enlaza con los sistemas de escritorio de Rentas, Agua y Limpieza; los contribuyentes de la municipalidad podrán visualizar sus cuentas canceladas o pendientes de pago."
              demo={true}
              techs={[javascript, html, css, iconMySql,iconPhp, sql]}
              github="https://github.com/Becessj/Publicacion-Web"
              linkDemo="https://github.com/Becessj/Publicacion-Web"
            />
          </>
        )}
      </div>

      <button type="button" className="show-more-btn" aria-expanded={showAll} onClick={() => setShowAll(!showAll)}>
        {showAll ? 'Ver menos proyectos' : 'Ver más proyectos (8)'}
      </button>

      <p className="text">Puedes ver todos mis proyectos en mi perfil de <a href="https://github.com/Becessj" title="github.com/Becessj" target="_blank" rel="noopener noreferrer">GitHub</a>.</p>
    </section>
  );
}
